export default __webpack_public_path__ + "static/media/cladding2.4162bd59.jpeg";